export default ({ COLORS }) => ({
  retirePupil: {
    color: COLORS.RED.NORMAL
  }
})
